import React from 'react';
import {Button, Modal, Space, Table, Typography} from 'antd';
import {EnvironmentOutlined, QrcodeOutlined} from '@ant-design/icons';
import {moneyMask} from '../../utils/utils';
import {GREE_1} from '../../utils/colors';
import PrescriptionBadge from './PrescriptionBadge';

const PAYMENT_METHOD_LABEL = {
    pix: {icon: <QrcodeOutlined/>, label: 'Pix', description: 'Pagamento instantâneo'},
};

export default function OrderConfirmModal({open, items, cart, address, shippingPrice, paymentMethod, loading, onConfirm, onCancel}) {
    const hasDiscount = cart?.discount_total && parseFloat(cart.discount_total) > 0;
    const grandTotal = shippingPrice !== null && shippingPrice !== undefined
        ? parseFloat(cart?.total || 0) + shippingPrice
        : parseFloat(cart?.total || 0);

    const columns = [
        {
            title: 'Produto',
            key: 'product',
            render: (_, item) => (
                <Space>
                    {item.product_image && (
                        <img
                            src={item.product_image}
                            alt={item.product_name}
                            style={{width: 40, height: 40, objectFit: 'cover', borderRadius: 4}}
                        />
                    )}
                    <Space direction="vertical" size={2}>
                        <Typography.Text strong>{item.product_name}</Typography.Text>
                        {item.requires_prescription && <PrescriptionBadge/>}
                    </Space>
                </Space>
            ),
        },
        {
            title: 'Qty',
            dataIndex: 'quantity',
            key: 'quantity',
            width: 60,
        },
        {
            title: 'Preço Unit.',
            key: 'current_price',
            render: (_, item) => item.discount_percentage ? (
                <Space direction="vertical" size={0}>
                    <Typography.Text delete style={{color: '#999', fontSize: 12}}>
                        R$ {moneyMask(item.current_price)}
                    </Typography.Text>
                    <Typography.Text strong style={{color: GREE_1}}>
                        R$ {moneyMask(item.discounted_price)}
                    </Typography.Text>
                    <Typography.Text style={{color: '#fa8c16', fontSize: 11}}>
                        -{item.discount_percentage}% receita
                    </Typography.Text>
                </Space>
            ) : `R$ ${moneyMask(item.current_price)}`,
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => (
                <Typography.Text strong style={{color: GREE_1}}>
                    R$ {moneyMask(val)}
                </Typography.Text>
            ),
        },
    ];

    return (
        <Modal
            title="Confirmar Pedido"
            open={open}
            onCancel={onCancel}
            width={700}
            footer={
                <Space>
                    <Button onClick={onCancel}>Cancelar</Button>
                    <Button
                        type="primary"
                        loading={loading}
                        onClick={onConfirm}
                        style={{background: GREE_1, borderColor: GREE_1}}
                    >
                        Confirmar Pedido
                    </Button>
                </Space>
            }
        >
            <Space direction="vertical" style={{width: '100%'}} size={16}>
                <Table
                    dataSource={items}
                    columns={columns}
                    rowKey="id"
                    pagination={false}
                    size="small"
                />

                {address && (
                    <div style={{
                        padding: '12px 16px',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        background: '#fafafa',
                    }}>
                        <Space>
                            <EnvironmentOutlined style={{color: GREE_1}}/>
                            <Space direction="vertical" size={0}>
                                <Typography.Text strong>
                                    {address.street}, {address.number}
                                    {address.complement ? ` - ${address.complement}` : ''}
                                </Typography.Text>
                                <Typography.Text type="secondary">
                                    {address.neighborhood} — {address.city} / {address.state} — CEP {address.postal_code}
                                </Typography.Text>
                            </Space>
                        </Space>
                    </div>
                )}

                {paymentMethod && PAYMENT_METHOD_LABEL[paymentMethod] && (
                    <div style={{
                        padding: '12px 16px',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        background: '#fafafa',
                    }}>
                        <Space>
                            {PAYMENT_METHOD_LABEL[paymentMethod].icon}
                            <Space direction="vertical" size={0}>
                                <Typography.Text strong>
                                    {PAYMENT_METHOD_LABEL[paymentMethod].label}
                                </Typography.Text>
                                <Typography.Text type="secondary" style={{fontSize: 12}}>
                                    {PAYMENT_METHOD_LABEL[paymentMethod].description}
                                </Typography.Text>
                            </Space>
                        </Space>
                    </div>
                )}

                <Space direction="vertical" size={4} style={{width: '100%', alignItems: 'flex-end'}}>
                    {hasDiscount && (
                        <>
                            <Typography.Text style={{color: '#999'}}>
                                Subtotal: R$ {moneyMask(cart.subtotal)}
                            </Typography.Text>
                            <Typography.Text style={{color: '#cf1322'}}>
                                Desconto: - R$ {moneyMask(cart.discount_total)}
                            </Typography.Text>
                        </>
                    )}
                    {shippingPrice !== null && shippingPrice !== undefined && (
                        <Typography.Text>
                            Frete: R$ {moneyMask(String(shippingPrice.toFixed(2)))}
                        </Typography.Text>
                    )}
                    <Typography.Title level={4} style={{margin: 0}}>
                        Total: R$ {moneyMask(String(grandTotal.toFixed(2)))}
                    </Typography.Title>
                </Space>
            </Space>
        </Modal>
    );
}
